import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { App360AuthSharedService } from '@nutricontrol/app360-auth-shared';

@Injectable()
export class CanActivateViaAuthGuard {
  private authService = inject(App360AuthSharedService);
  private router = inject(Router);

  private response = false;

  async canActivate() {
    await this.callService();
    if (this.response === false) {
      await this.router.navigate(['/']);
      return false;
    }
    return true;
  }

  callService() {
    return new Promise((resolve, reject) => {
      this.authService.checkAuth().subscribe(
        (res) => {
          this.response = true;
          resolve(res);
        },
        (error) => {
          resolve(error);
        }
      );
    });
  }
}
